import React from 'react';
import { View, StyleSheet } from 'react-native';
import { BText } from '../BText';
import { themeConfig } from '../../styles/themeConfig';

type props = {
  onClose: any;
};

export const CancelRegistration = ({ onClose }: props) => {
  return (
    <View style={styles.container}>
      <BText style={styles.message}>
        Please contact the event organizer directly in order to cancel your registration.
      </BText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: themeConfig.colors.white,
    borderRadius: themeConfig.settings.borderRadius,
    color: themeConfig.colors.black,
  },
  message: {
    fontSize: 14,
    paddingTop: 4,
  },
});
